import { render, staticRenderFns } from "./stepper2.vue?vue&type=template&id=dfcca592"
import script from "./stepper2.vue?vue&type=script&lang=js"
export * from "./stepper2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports